import { render } from "./paperDownloadConig.vue?vue&type=template&id=712126ae&scoped=true"
import script from "./paperDownloadConig.vue?vue&type=script&lang=js"
export * from "./paperDownloadConig.vue?vue&type=script&lang=js"

import "./paperDownloadConig.vue?vue&type=style&index=0&id=712126ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712126ae"]])

export default __exports__